<template>
  <el-container v-loading="loading" class="pro-intro">
    <el-header class="m-header">
      <div class="dflex" v-if="exitsOfficialVersion">
        <div class="flex1" style="width:100%">
          <span class="title">{{ proinfo.productName }}</span>
          <div class="lightgreen-box" v-if="exitsFile">
            {{ alllanguages.fileSize[key] }}: {{ proinfo.size }}
          </div>
          <div class="lightgreen-box">
            {{ alllanguages.ver[key] }}: {{ proinfo.versionNumber }}
          </div>
          <div class="lightgreen-box">{{ proinfo.validTime }}</div>
        </div>
        <div class="btn-box">
          <el-button
          v-if="exitsFile || appMarketLink !== ''"
            class="orange-box"
            @click="download()"
            >{{ alllanguages.download[key] }}</el-button
          >
        </div>
      </div>
      <div v-else class="no-version">不存在已发布版本</div>
    </el-header>
    <el-main class="content" v-if="exitsOfficialVersion">
      <div class="update-desc">{{ alllanguages.updated[key] }}</div>
      <p >{{ proinfo.updateContent }}</p>
      <div class="pro-intro">{{ alllanguages.product[key] }}</div>
      <p>{{ proinfo.productDescribe }}</p>
    </el-main>
  </el-container>
</template>

<script>
// import Vue from 'vue'
import httpMethods from '@/api/version/http.js'
import encryption from '../../utils/encryption.js'
import config from '@/config'
// import { decode } from 'punycode'
export default {
  data() {
    return {
      exitsOfficialVersion: true, // 产品是否存在正式版本
      exitsFile: false, // 是否存在安装包文件
      time: '', // sm2获取的时间戳
      publickey: '', // sm2获取公钥
      loading: true,
      versionId: '',
      size: '',
      key: 'zh-CN',
      appMarketLink: '', // 应用市场链接
      defaultkey: 'zh-CN', // 没有多语言列表时，默认显示中文
      proinfo: {
        productName: ''
      },
      alllanguages: {
        fileSize: {
          'zh-CN': ''
        },
        ver: {
          'zh-CN': ''
        },
        updated: {
          'zh-CN': ''
        },
        product: {
          'zh-CN': ''
        },
        download: {
          'zh-CN': ''
        }
      }
    }
  },
  mounted() {
    this.productId = decodeURIComponent(this.$route.query.productId)
    this.exitsFile = false
    this.versionId = this.$route.query.versionId
    if (this.versionId) {
      this.versionId = decodeURIComponent(this.versionId)
      this.getInfo()
    } else {
      this.versionId = null
      this.getLastVersion()
    }
  },
  methods: {
    // 获取当前版本详情
    getInfo() {
      this.$http({
        url: this.$http.adornUrl('/api/app/getProductVersionMultiLanguage'),
        method: 'get',
        params: this.$http.adornParams({
          versionId: this.versionId,
          type: 1 // 访客访问
        })
      })
        .then((res) => {
          this.loading = false
          const data = res.data
          if (data && res.resp_code === 0) {
            this.proinfo = res.data
            if (this.proinfo.fileName && this.proinfo.fileName !== '') {
              this.exitsFile = true
            }
            if (
              this.proinfo.appMarketLink !== '' &&
              this.proinfo.appMarketLink !== null
            ) {
              this.appMarketLink = this.proinfo.appMarketLink.split(';')[0]
            } else {
              this.appMarketLink = ''
            }
            this.getAllLanguages()
          } else {
            this.proinfo = {}
            this.appMarketLink = ''
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {})
    },
    // 产品二维码通过产品id获取当前产品的最新版本
    getLastVersion() {
      this.$http({
        url: this.$http.adornUrl('/api/app/getLatestProductVersion'),
        method: 'get',
        params: this.$http.adornParams({
          productId: this.productId,
          type: 1 // 访客访问
        })
      })
        .then((res) => {
          this.loading = false
          const data = res.data
          if (data && res.resp_code === 0) {
            this.proinfo = res.data
            if (this.proinfo.versionNumber === null) {
              // 不存在最新发布版本
              this.exitsOfficialVersion = false
            } else {
              this.exitsOfficialVersion = true
            }
            if (this.proinfo.fileName && this.proinfo.fileName !== '') {
              this.exitsFile = true
            }
            if (
              this.proinfo.appMarketLink !== '' &&
              this.proinfo.appMarketLink !== null
            ) {
              this.appMarketLink = this.proinfo.appMarketLink.split(';')[0]
            } else {
              this.appMarketLink = ''
            }
            this.getAllLanguages()
          } else {
            this.proinfo = {}
            this.appMarketLink = ''
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {})
    },
    // 获取多语言列表所有语言描述信息
    getAllLanguages() {
      httpMethods
        .allLanguages()
        .then((res) => {
          this.loading = false
          const data = res.data
          if (data && res.resp_code === 0) {
            this.alllanguages = res.data
            this.key = navigator.language
            const arr = ['en', 'fr', 'de', 'it', 'pt', 'es', 'hu', 'ja', 'ko', 'pl', 'ru', 'tr']
            arr.forEach((item) => {
              if (this.key.indexOf(item) !== -1) {
                this.key = item
              }
            })
            if (this.key === 'zh-HK') {
              this.key = 'zh-TW'
            }
            // 测试华为中文key,中文简体和中文繁体都是zh-cn？？待确定
            if (this.key.indexOf('zh-cn') !== -1) {
              this.key = 'zh-CN'
            }
            if (this.key !== 'zh-CN') {
              if (this.proinfo.list && this.proinfo.list.length > 0) {
                for (let i = 0; i < this.proinfo.list.length; i++) {
                  if (this.proinfo.list[i].languageKey === this.key) {
                    this.proinfo.updateContent = this.proinfo.list[i].multiLanguageupdateContent
                    break
                  }
                }
              }
              if (this.proinfo.productInfoList && this.proinfo.productInfoList.length > 0) {
                for (let i = 0; i < this.proinfo.productInfoList.length; i++) {
                  if (this.proinfo.productInfoList[i].languageKey === this.key) {
                    this.proinfo.productName = this.proinfo.productInfoList[i].multiLanguageProductName
                    this.proinfo.productDescribe = this.proinfo.productInfoList[i].multiLanguageProductDescribe
                    break
                  }
                }
              }
            }
            // switch (this.key) {
            //   case 'en-us': // 英语
            //     this.key = 'en-us'
            //     break
            //   case 'ja': // 日语
            //     this.key = 'ja-jp'
            //     break
            //   case 'pl': // 波兰语
            //     this.key = 'pl-pl'
            //     break
            //   case 'ko': // 韩语
            //     this.key = 'ko-kr'
            //     break
            //   case 'ru': // 俄语
            //     this.key = 'ru-ru'
            //     break
            //   case 'hu': // 匈牙利语
            //     this.key = 'hu-hu'
            //     break
            //   case 'tr': // 土耳其语
            //     this.key = 'tr-tr'
            //     break
            //   case 'it': // 意大利语
            //     this.key = 'it-it'
            //     break
            //   case 'pt': // 葡萄牙
            //     this.key = 'pt-pt'
            //     break
            //   case 'es': // 西班牙
            //     this.key = 'es-es'
            //     break
            //   // default:
            //   //   this.key = 'zh-cn'
            // }
          } else {
            this.alllanguages = {}
            this.$message.error(res.resp_msg)
          }
        })
        .catch(() => {})
    },
    // 下载
    download() {
      if (this.exitsFile) {
        // 有安装包，下载文件
        // 先判断是否能下载
        const id = encryption.Encrypt(this.proinfo.productId)

        const versionNumber = encryption.Encrypt(this.proinfo.versionNumber)
        // const id = encryption.Encrypt('1448582521259663361').replace(/\s+/g, '%2B')
        // const versionNumber = encryption.Encrypt('V2.0.1').replace(/\s+/g, '%2B')
        window.location.href =
          config.baseURL +
          '/api/app/download/productVersion?codeProductId=' +
          encodeURIComponent(id) +
          '&codeVersion=' +
          encodeURIComponent(versionNumber)
      } else {
        // 无安装包，打开链接
        window.open(this.appMarketLink)
      }
    }
    // 判断安装包是否能下载
    // judgeCanDownload() {
    //   this.$http({
    //     url: this.$http.adornUrl('/api/app/upgradeAndFileInfo'),
    //     method: 'get',
    //     params: this.$http.adornParams({
    //       productId: this.productId
    //     })

    //   }).then(res => {
    //     if (res.resp_code === 0) {
    //       if (res.data !== null) { // 可以下载
    //         const id = encryption.Encrypt(this.proinfo.productId)
    //         const versionNumber = encryption.Encrypt(this.proinfo.versionNumber)
    //         window.location.href = config.baseURL + `/api/app/download/productVersion?codeProductId=${id}&codeVersion=${versionNumber}`
    //       } else {
    //         this.$message.error(res.resp_msg)
    //       }
    //     }
    //   })
    // }
    // download() {
    //   if (this.proinfo.versionNumber !== '') { // 指定版本的信息
    //     // const sm2 = require('sm-crypto').sm2
    //     // const cipherMode = 0 // 1 - C1C3C2，0 - C1C2C3，默认为1
    //     // const id = sm2.doEncrypt(this.proinfo.productId, this.publickey, cipherMode) // sm2加密  产品id待返回
    //     // const versionNumber = sm2.doEncrypt(this.proinfo.versionNumber, this.publickey, cipherMode) // sm2加密
    //     const id = encryption.Encrypt(this.proinfo.productId)
    //     const versionNumber = encryption.Encrypt(this.proinfo.versionNumber)
    //     // const token = Vue.cookie.get('token')
    //     // window.location.href = config.baseURL + `/api/app/download/${id}/${versionNumber}`
    //     window.location.href = config.baseURL + `/api/app/download/productVersion?codeProductId=${id}&codeVersion=${versionNumber}`
    //   } else if (this.proinfo.versionNumber === '' && this.appMarketLink !== '') { // 产品的最新版本的信息
    //     window.open(this.appMarketLink)
    //   }
    // }
    // 获取sm2的公钥和时间戳
    // getKeys() {
    //   httpMethods
    //     .keys()
    //     .then((res) => {
    //       console.log(res)
    //       this.loading = false
    //       const data = res.data
    //       if (data && res.resp_code === 0) {
    //         this.publickey = '04' + res.data.PulicKey
    //         this.time = res.data.time
    //         this.getInfo()
    //       } else {
    //         this.publickey = ''
    //         this.time = ''
    //         this.$message.error(res.resp_msg)
    //       }
    //     })
    //     .catch(() => {})
    // }
  }
}
</script>
<style lang="scss" scoped>
.no-version {
  color: #fff;
  text-align: center;
  line-height: 180px;
}
::v-deep {
  .el-header {
    background-color: #b3c0d1;
    color: #333;
    text-align: left;
    line-height: 30px;
    height: 200px;
    padding: 0 5%;
  }
  .el-main {
    background-color: #e9eef3;
    color: #333;
    text-align: left;
    height: calc(100vh - 180px);
  }
  .m-header {
    background: url('../../assets/img/banner.png') no-repeat;
    height: 180px !important;
    background-size: 100% 100%;
  }
}

.title {
  color: #e9eef3;
  line-height: 50px;
  font-size: 20px;
  font-weight: bold;

  overflow: hidden;
    /* white-space: nowrap; */
    text-overflow: ellipsis;
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    /* overflow: hidden; */
    /* text-overflow: ellipsis; */
    /* word-break: break-all; */
    /* display: -webkit-box; */
    -webkit-box-orient: vertical;

}
.lightgreen-box {
  color: #e9eef3;
  line-height: 30px;
  // width:65%;
}
.orange-box {
  float: right;
  // margin-right: 20px;
  // margin-top: -90px;
  background-color: #7728f5;
  color: white;
  border: none;
}
.btn-box {
  // width: 20%;
  padding-top: 50px;
}
.content {
  .update-desc {
    font-weight: bold;
  }
  .pro-intro {
    margin-top: 30px;
    font-weight: bold;
  }
}
@media screen and (max-width: 768px){
  .title {
  line-height: 30px;
  font-size: 18px;
}
 .flex1{
  margin-top:15px;
 }

}
</style>
